import { MRT_ColumnDef } from "material-react-table";
import {
  EntityWithMetadataTableSuffixColumns,
  createConnectionFilterSpec,
} from "./EntityUtils";
import { AncillaryConnection } from "../../types/ancillary";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import type { FilterSpec } from "../../hooks/useServerFilters";

export const ancillaryColumns: MRT_ColumnDef<AncillaryConnection>[] = [
  {
    id: "fromDoc",
    accessorFn: (row) => row.fromDoc?.published_id || row._from,
    header: "From Work",
    Cell: ({ row }) => (
      <EntityReferenceComponent entity={row.original.fromDoc} />
    ),
    enableColumnFilter: false,
  },
  {
    id: "toDoc",
    accessorFn: (row) => row.toDoc?.published_id || row._to,
    header: "To Work",
    Cell: ({ row }) => <EntityReferenceComponent entity={row.original.toDoc} />,
    enableColumnFilter: false,
  },
  {
    id: "work_ancillary_type",
    accessorFn: (row) => (row as any).work_ancillary_type,
    header: "Ancillary Type",
  },
  ...EntityWithMetadataTableSuffixColumns,
];

// fromDoc/toDoc are excluded: their enriched values aren't available to the
// backend filter, which runs before enrichment.
export const ancillaryFilterSpec: FilterSpec = createConnectionFilterSpec({
  work_ancillary_type: { kind: "string" },
});
